'use client'
import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

type FoodCardProps = {
  imageUrl?: string
  title?: string
  description?: string
  categoryName?: string
  link?: string
  isLoading?: boolean
}

const FoodCard: React.FC<FoodCardProps> = ({
  imageUrl = '',
  title = '',
  description = '',
  categoryName = '',
  link = '',
  isLoading = false,
}) => {
  return (
    <article className="relative flex border-b border-gray-300 p-4 hover:shadow-lg transition-shadow duration-300">
      {/* Loading Skeleton */}
      {isLoading ? (
        <div className="w-full h-48 bg-gray-300 animate-pulse" />
      ) : (
        <Link href={`/${link}`} className="flex w-full">
          {/* Bên trái: Chữ */}
          <div className="flex-1 pr-4">
            <div className="mb-2">
              <span className="text-sm text-tagBlue font-medium">{categoryName}</span>
            </div>
            <h3 className="text-xl font-title font-semibold text-gray-900 hover:text-primary transition duration-200">
              {title}
            </h3>
            <p className="text-sm text-gray-600 mt-2 line-clamp-3">{description}</p>
          </div>

          {/* Bên phải: Hình ảnh */}
          <div className="relative w-40 h-28 flex-shrink-0">
            <Image
              src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${imageUrl}`}
              alt={title}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 680px"
              className="object-cover"
              priority
              unoptimized
            />
          </div>
        </Link>
      )}
    </article>
  )
}

export default FoodCard
